export default {
	title: "Relatórios",
	selectReport: "Selecione um relatório para visualizar",
	ritualReport: "Relatório de Ritual",
	noClosedRituals: "Nenhum ritual fechado encontrado",
	requiresClosed: "É necessário que o ritual seja fechado para ter acesso ao relatório.",
	closings: {
		title: "Fechamentos de Ritual",
		description: "Relatórios detalhados de rituais fechados",
		totalClosed: "Rituais fechados",
	},
	print: "Imprimir",
	sendEmail: "Enviar por email",
	emailSent: "Relatório enviado para seu email",
	emailError: "Erro ao enviar relatório por email",
	printHeader: {
		printedAt: "Impresso em",
	},
	back: "Voltar",
	header: {
		type: "Tipo",
		spiritualLine: "Linha Espiritual",
		date: "Data",
		location: "Local",
		openedBy: "Aberto por",
		closedBy: "Fechado por",
	},
	stats: {
		title: "Estatísticas",
		ritualDuration: "Duração do Ritual",
		attendanceDuration: "Duração dos Atendimentos",
		firstCall: "Primeira Chamada",
		lastCall: "Última Chamada",
		avgIncremental: "Tempo Médio (Sob Demanda)",
		avgPreDefined: "Tempo Médio (Fixas)",
		totalTickets: "Total de Fichas",
		cancelledTickets: "Canceladas",
		newPersons: "Pessoas Novas",
		minutes: "min",
		notAvailable: "N/D",
	},
	tickets: {
		title: "Fichas de Atendimento",
		code: "Ficha",
		person: "Consulente",
		createdAt: "Criação",
		calledAt: "Chamada",
		finishedAt: "Fim",
		elapsed: "Duração",
		status: "Status",
		medium: "Médium",
		guide: "Guia",
		avgTime: "Tempo médio",
		noTickets: "Nenhuma ficha neste grupo",
	},
	messages: {
		title: "Mensagens",
		type: "Tipo",
		severity: "Severidade",
		message: "Mensagem",
		person: "Pessoa",
		createdBy: "Criado por",
	},
	returns: {
		fulfilledTitle: "Retornos Cumpridos neste Ritual",
		newTitle: "Novos Retornos",
		returnType: "Tipo",
		person: "Consulente",
		target: "Destino",
		status: "Status",
		notes: "Observações",
		fulfilled: "Cumprido",
		pending: "Pendente",
	},
	general: {
		title: "Relatório Geral de Rituais",
		menuTitle: "Relatório Geral",
		fetchError: "Erro ao carregar o relatório",
		exportPdf: "Exportar PDF",
		pdfError: "Erro ao gerar o PDF",
		minutesShort: "min",
		filters: {
			status: "Status",
			allPeriods: "Todo o período",
		},
		empty: {
			title: "Nenhum ritual no período",
			description: "Ajuste o período ou os status selecionados para ver os resultados.",
		},
		groups: {
			byRitual: "Visão por ritual",
			byType: "Distribuição por tipo",
			mediums: "Desempenho dos médiuns",
		},
		kpis: {
			rituals: "Rituais",
			completedTickets: "Atendimentos",
			distinctPersons: "Pessoas atendidas",
			cancelledTickets: "Fichas canceladas",
			totalTime: "Tempo total",
			avgTime: "Tempo médio",
		},
		charts: {
			ticketsByRitual: "Atendimentos por ritual",
			ticketsByRitualType: "Atendimentos por tipo de ritual",
			avgByRitualType: "Média de atendimentos por tipo de ritual",
			ticketDistribution: "Distribuição das fichas",
			topMediumsByTime: "Médiuns com maior tempo de atendimento",
			topMediumsByAvg: "Médiuns com maior média de atendimentos",
			attendances: "Atendimentos",
			avgAttendances: "Média de atendimentos",
			attendancesShort: "atend.",
			tickets: "fichas",
			completed: "Concluídas",
			notCompleted: "Não concluídas",
			cancelled: "Canceladas",
			totalTime: "Tempo total",
		},
		byMedium: {
			title: "Por médium",
			medium: "Médium",
			attendances: "Atendimentos",
			rituals: "Rituais",
			totalTime: "Tempo total",
			avgTime: "Tempo médio",
			empty: "Nenhum médium com atendimentos no período",
		},
		byGuide: {
			title: "Por guia",
			guide: "Guia",
			medium: "Médium",
			attendances: "Atendimentos",
			totalTime: "Tempo total",
			avgTime: "Tempo médio",
			empty: "Nenhum guia com atendimentos no período",
		},
	},
};
